module.exports = __webpack_public_path__ + "img/danger-chat-ill.352774ee.png";